import React, { Component } from 'react';
import styles from './banner_nav.css';
import iconBenefits from '../../assets/icons/ICN_Benefits.svg';
import iconSpecs from '../../assets/icons/ICN_Specs.svg';
import iconGallery from '../../assets/icons/ICN_Gallery.svg';
import iconRegion from '../../assets/icons/ICN_Region.svg';
import Lang from '../../i18n'
import { withRouter } from 'react-router-dom'

class BannerNav extends Component {

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.containerInner}>
          <div className={styles.item}>
            <a href={Lang.translate('banner:benefitsLink', this.props.location.pathname)} target="_blank" rel="noopener noreferrer">
              <img src={iconBenefits} alt="" />
              <span>{Lang.translate('banner:benefits', this.props.location.pathname)}</span>
            </a>
          </div>
          <div className={styles.item}>
            <a href={Lang.translate('banner:technicalLink', this.props.location.pathname)} target="_blank" rel="noopener noreferrer">
              <img src={iconSpecs} alt="" />
              <span>{Lang.translate('banner:technical', this.props.location.pathname)}</span>
            </a>
          </div>
          <div className={styles.item}>
            <a href={Lang.translate('banner:multiMediaLink', this.props.location.pathname)} target="_blank" rel="noopener noreferrer">
              <img src={iconGallery} alt="" />
              <span>{Lang.translate('banner:multiMedia', this.props.location.pathname)}</span>
            </a>
          </div>
          <div className={styles.item}>
            <a href={Lang.translate('banner:contactLink', this.props.location.pathname)} target="_blank" rel="noopener noreferrer">
              <img src={iconRegion} alt="" />
              <span>{Lang.translate('banner:contact', this.props.location.pathname)}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BannerNav);



// WEBPACK FOOTER //
// ./src/components/banner_nav/banner_nav.js